var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewJersey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.604,46.16c-4.388-5.115-62.154-21.204-62.154-21.204L106.159,33l2.979,13.16c0,0-11.7,16.089-11.7,20.477 c0,4.385,8.777,13.893,3.659,18.279c-5.119,4.389-9.508,16.816-2.925,21.204c6.579,4.39,28.066,24.865,28.066,24.865 s11.415,4.384,11.415,9.504c0,5.118-24.126,32.172-22.665,34.369c1.463,2.192-18.281,10.966-18.281,10.966s-2.21,7.843-3.95,12.043 l-0.012,0.026c0,0,2.497,6.943,13.105,19.373c10.604,12.433,45.334,17.552,45.334,17.552l-4.872,13.162l4.872,14.625l12.794-15.356 v-20.476c13.164-12.43,31.446-63.8,31.446-63.8l-2.929-10.053V110.51l-8.042-16.819l-14.624,8.776l-5.852-5.851l18.998-20.114 c-2.299-1.422-3.64-2.557-3.64-2.557S182.992,51.28,178.604,46.16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJersey);
export default __webpack_public_path__ + "static/media/newJersey.abb27c1500729c4e9c1bebf1dd11ac69.svg";
export { ForwardRef as ReactComponent };